import { Row,Col, Button } from "reactstrap";
import { StatusList } from './FormComponents';
import { useState, useContext, useEffect,ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/free-solid-svg-icons';
import { PageContext } from './PageContext';
import { UserContext } from "./UserContext";
import { mmJob } from "../services/interfaces";
import { showFields,fieldLables } from "./Configuration";




export function MMJobJacket(selectedJob:mmJob){
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);

    //console.log(pageContext?.uiFeatures);
   

    const ajDisabled = ()=>{
        //console.log("AdJacket Enabled: " + pageContext?.uiFeatures.adJacketEnabled);
        return (!pageContext?.uiFeatures.adJacketEnabled);
    }
    const ajTaglineDisabled = ()=>{
        //console.log("Tagline Enabled: " + pageContext?.uiFeatures.editTagLine);
        return (!pageContext?.uiFeatures.editTagLine);
    }

    function copyClipboard(field:string){
        var fieldVal = "";
        // switch(field){
        //     case "slug":
        //         fieldVal=pageContext?.selectedAd.slug || "";
        //         break
        //     case "customer":
        //         fieldVal=ajFields.Customer || "";
        //         break;
        //     case "account":
        //         fieldVal=ajFields.Account || "";
        //         break;
        //     case "site":
        //         fieldVal=ajFields?.Site || "";
        //         break;
        //     case "salesman":
        //         fieldVal=ajFields?.Salesman || "";
        //         break;
        //     case "type":
        //         fieldVal=ajFields?.Type || "";
        //         break;
        //     case "tagline":
        //         fieldVal=ajFields?.Tagline || "";
        //         break;
        //     case "comment":
        //         fieldVal=ajFields?.Comment || "";
        //         break;
        //     case "parent":
        //         fieldVal=ajFields?.ParentAd || "";
        //         break;
        //     case "rcopylines":
        //         fieldVal=ajFields?.rCopyLines || "";
        //         break;
        //     case "tmpchar2":
        //         fieldVal=ajFields?.TmpChar2 || "";
        //         break;
        //     case "rcopyuo":
        //         fieldVal=ajFields?.rCopyUO || "";
        //         break;
        // }
        navigator.clipboard.writeText(fieldVal);
    }

    

   

    //console.log(pageContext?.selectedAd);
    useEffect(()=>{
        console.log(selectedJob);
        //fetchLabels();
        //fetchShow();
    },[]);

    return(
        <div className="expand-tab-content">      
            <Row>
                <Col xs="3">Customer</Col>
                <Col xs="9">        
                    <input id="majCustomer" className="formField" value={selectedJob.customer} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Due Within:</Col>
                <Col xs="9">        
                    <input id="majTurnaround" className="formField" value={selectedJob.turnaroundTime} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Job Type:</Col>
                <Col xs="9">        
                    <input id="majJobType" className="formField" value={selectedJob.jobType} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Return Type:</Col>
                <Col xs="9">        
                    <input id="majReturnType" className="formField" value={selectedJob.returnType} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Color Options:</Col>
                <Col xs="9">        
                    <input id="majColor" className="formField" value={selectedJob.color} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Needs Cropping:</Col>
                <Col xs="3">        
                    <input id="majNeedsCropping" className="formField" value={selectedJob.needsCropping} disabled={true}></input>
                </Col>
                <Col xs="2">        
                    <input id="majNeedsCropping" className="formField" value={""} disabled={true}></input>
                </Col>
                <Col xs="2">        
                    X
                </Col>
                <Col xs="2">        
                    <input id="majNeedsCropping" className="formField" value={""} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">COB Type:</Col>
                <Col xs="9">        
                    <input id="majNeedsCropping" className="formField" value={selectedJob.cob} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Return Format:</Col>
                <Col xs="9">        
                    <input id="majNeedsCropping" className="formField" value={selectedJob.format} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="3">Return Resolution:</Col>
                <Col xs="9">        
                    <input id="majNeedsCropping" className="formField" value={selectedJob.resolution} disabled={true}></input>
                </Col>
            </Row>
            <Row>
                <Col xs="12">Special Instructions:</Col>
            </Row>
            <Row>
                <Col xs="12">        
                    <textarea id="majNeedsCropping" className="formField" value={selectedJob.specialInstructions} disabled={true}></textarea>
                </Col>
            </Row>
            <Row>
                <Col xs="12">Job Description:</Col>
            </Row>
            <Row>
                <Col xs="12">        
                    <textarea id="majNeedsCropping" className="formField" value={selectedJob.jobDescription} disabled={true}></textarea>
                </Col>
            </Row>
            </div>
    );
}